import type { SubscriptionPlan } from '../Subscriptions.types'
import { useSubscriptionPlansQuery } from '../queries/useSubscriptionPlansQuery'

type TopSubscriptionPlanParams = {
  recurringPeriod: SubscriptionPlan['recurringPeriod']
}

export const useTopSubscriptionPlan = (params?: TopSubscriptionPlanParams) => {
  const { recurringPeriod = 'MONTHLY' } = params || {}
  const { subscriptionPlansQuery } = useSubscriptionPlansQuery()

  const topSubscriptionPlan = subscriptionPlansQuery.data?.find(
    (plan) => plan.pro && !plan.custom && plan.recurringPeriod === recurringPeriod,
  )

  const getTopSubscriptionPlanLimitLabel = (
    attribute: 'domains' | 'offers' | 'members',
    capitalize: boolean = false,
  ) => {
    if (!subscriptionPlansQuery.data) return 0

    const limit = subscriptionPlansQuery.data[0][`${attribute}Limit`]
    const isUnlimited = limit === -1

    const result = isUnlimited ? 'unlimited' : `up to ${limit}`

    return capitalize ? result.charAt(0).toUpperCase() + result.slice(1) : result
  }

  return {
    topSubscriptionPlan,
    getTopSubscriptionPlanLimitLabel,
  }
}
